import { FunctionComponent } from 'react';

type ExpandIconProps = {
  width?: number | string;
  height?: number | string;
  active?: boolean;
};

const ExpandIcon: FunctionComponent<ExpandIconProps> = ({
  width = 34,
  height = 34,
  active = false,
}) => {
  const circleFill = active ? '#561BDC' : '#FAFAFA';
  const strokeColor = active ? '#EDEDED' : '#3E3B5F';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 34 34"
    >
      <g transform="translate(-872 -962)">
        <circle
          cx="17"
          cy="17"
          r="17"
          transform="translate(872 962)"
          fill={circleFill}
        />
        <g transform="translate(23.561 63.561)">
          <rect
            width="6.462"
            height="6.462"
            transform="translate(856.439 917.978)"
            fill="none"
            stroke={strokeColor}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <path
            d="M64,17.693V8H78.77V22.77H69.077"
            transform="translate(795.669 898.439)"
            fill="none"
            stroke={strokeColor}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <line
            y1="5.257"
            x2="5.257"
            transform="translate(864.426 911.196)"
            fill="none"
            stroke={strokeColor}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <path
            d="M172.205,124.205V120H168"
            transform="translate(697.477 791.196)"
            fill="none"
            stroke={strokeColor}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
        </g>
      </g>
    </svg>
  );
};

export default ExpandIcon;
